import React, { useState } from 'react';
import moment from 'moment/moment';

import Coin from 'components/Images/Coin';
import Money from 'components/Images/Money';
import { Popup } from 'components/Popup';
import { isMobileOrTablet } from 'pages/Home/helpers';
import { StyledTopLine } from 'pages/Home/NewWBPCards/UserRetention/styled';
import { Box, Button as StyledButton, Text } from 'designSystem';
import ICONOGRAPHY from 'designSystem/icons/strokeIcons';

import ChevronDown from '../../../components/Images/ChevronDown';
import ImportantNoteIcon from '../../../components/Images/ImportantNoteIcon';
import { handleNotionOrExternalLink } from '../../../lib/utils';
import LinkOut from '../images/link.png';
import Medal from '../images/trophy-medal.svg';
import Stage1 from '../images/trophy1.svg';
import Stage2 from '../images/trophy2.svg';
import Stage3 from '../images/trophy3.svg';
import trophy4_bottom from '../images/trophy4_bottom.svg';
import Stage4 from '../images/trophy4.svg';
import Stage5 from '../images/trophy5.svg';
import {
  BtnContainer,
  Button,
  CardChevronBtn,
  CardContainer,
  CardWrapper,
  Dot,
  FlexContainer,
  LiveContainer,
  MinWidthSetter,
  NotesPoints,
  NumberOfWinners,
  Prize1Div,
  Prize2Div,
  Prize3Div,
  Prize4Div,
  RewardAmount,
  RewardNote,
  RewardNoteBottom,
  StageAndPrizeCardContainer,
  StageCardHeading,
  StageSubHeading,
  StageTable,
  StyledExternalWrapper,
  StyledPopupWrapper,
  StyledPrize1Div,
  StyledPrize2Div,
  StyledPrize3Div,
  StyledRewardAmount,
  StyledRewardNote,
  StyledRewards,
  StyledTrophy,
  StyledTrophy2,
  StyledWinnersLabel,
  Trophy,
  VerticalCenterItems,
} from '../style';

const { money: MoneyIcon, coin: CoinIcon } = ICONOGRAPHY;

const AllPrizesPopup = ({ onClose, getRewardAmountCoin, ...props }) => {
  const trophySrcArr = [Stage4, Stage5, Medal];

  return (
    <Popup
      show
      className={
        isMobileOrTablet()
          ? `bottom-sheet calender-details no-margin no-padding ${props.extraWinners.length > 2 ? 'extra-winners' : ''}`
          : `${props.extraWinners.length > 2 ? 'extra-winners-web' : ''}`
      }
      close={onClose}
      fullHeight="full-height-details"
    >
      <Box>
        <StyledExternalWrapper>
          {isMobileOrTablet() && <StyledTopLine />}
          <Text my={16} variant="titleMedium" textAlign="center">
            Contest Prize List
          </Text>
          <StyledPopupWrapper>
            <StyledPrize1Div>
              <StyledTrophy src={Stage1} alt="Prize 1" />
              {props.winner1_no && (
                <StyledWinnersLabel>
                  {props.winner1_no}{' '}
                  {props.winner1_no > 1 ? 'WINNERS' : 'WINNER'}
                </StyledWinnersLabel>
              )}
              <StyledRewards>
                <StyledRewardAmount>
                  {getRewardAmountCoin(
                    props?.winner1_amount,
                    props?.winner1_coin
                  )}
                </StyledRewardAmount>
                <div style={{ display: 'flex' }}>
                  <RewardNote>{props.winner1_reward_note}</RewardNote>
                </div>
              </StyledRewards>
            </StyledPrize1Div>
            <StyledPrize2Div>
              <StyledTrophy2 src={Stage2} alt="Prize 2" />
              {props.winner2_no && (
                <StyledWinnersLabel>
                  {props.winner2_no}{' '}
                  {props.winner2_no > 1 ? 'WINNERS' : 'WINNER'}
                </StyledWinnersLabel>
              )}
              <StyledRewards>
                <StyledRewardAmount>
                  {getRewardAmountCoin(
                    props?.winner2_amount,
                    props?.winner2_coin
                  )}
                </StyledRewardAmount>
                <div style={{ display: 'flex' }}>
                  <StyledRewardNote>
                    {props.winner2_reward_note}
                  </StyledRewardNote>
                </div>
              </StyledRewards>
            </StyledPrize2Div>
            <StyledPrize3Div>
              {props.winner3_no && (
                <StyledWinnersLabel>
                  {props.winner3_no}{' '}
                  {props.winner3_no > 1 ? 'WINNERS' : 'WINNER'}
                </StyledWinnersLabel>
              )}
              <StyledTrophy src={Stage3} alt="Prize 3" />
              <StyledRewards>
                <StyledRewardAmount>
                  {getRewardAmountCoin(
                    props?.winner3_amount,
                    props?.winner3_coin
                  )}
                </StyledRewardAmount>
                <div style={{ display: 'flex' }}>
                  <StyledRewardNote>
                    {props.winner3_reward_note}
                  </StyledRewardNote>
                </div>
              </StyledRewards>
            </StyledPrize3Div>
            {props?.extraWinners?.map((winner, index) => (
              <StyledPrize3Div
                key={winner.winner_no}
                bgColor="#32302E"
                fullWidth
              >
                {winner.winner_no && (
                  <StyledWinnersLabel>
                    {`${winner.winner_no}`}{' '}
                    {winner.winner_no > 1 ? 'WINNERS' : 'WINNER'}
                  </StyledWinnersLabel>
                )}
                <StyledTrophy
                  src={index > 1 ? trophySrcArr[2] : trophySrcArr[index]}
                />
                <StyledRewards>
                  <StyledRewardAmount>
                    {getRewardAmountCoin(
                      winner?.winner_amount,
                      winner?.winner_coin
                    )}
                  </StyledRewardAmount>
                  <div style={{ display: 'flex' }}>
                    <StyledRewardNote>
                      {winner.winner_reward_note}
                    </StyledRewardNote>
                  </div>
                </StyledRewards>
              </StyledPrize3Div>
            ))}
          </StyledPopupWrapper>
        </StyledExternalWrapper>
      </Box>
    </Popup>
  );
};

export default function StageContainer({
  handleJoinContestBtn,
  checkContestStatus,
  heading,
  toggleExtraInfoHandler,
  reward_notes,
  important_points,
  notes,
  sub_heading,
  result_date,
  min_words,
  end_date,
  sub_heading_hyperlink,
  imp_reward_notes,
  reward_type,
  ...props
}) {
  const [isAllPrizesShown, toggleShowAllPrizes] = useState(false);
  const handleRewardNotes = () => {
    return reward_notes.split('\n');
  };

  function getRewardAmountCoin(winnerAmount, winnerCoin) {
    switch (reward_type) {
      case 'coin':
        return (
          <div className="center">
            <CoinIcon />
            {winnerCoin} coins
          </div>
        );

      case 'monetary':
      case undefined:
        return (
          <div className="center">
            <MoneyIcon />
            {` ${props?.moneySymbol}`}
            {winnerAmount}
          </div>
        );

      case 'monetary_coin':
        return (
          <div className="v-d-flex">
            <div>
              <MoneyIcon /> {` ${props?.moneySymbol}`}
              {winnerAmount}
              <span> +</span>
            </div>
            <div className="d-flex">
              <div className="coin">
                <CoinIcon />
              </div>
              {` ${winnerCoin}`} coins
            </div>
          </div>
        );

      default:
        return null; // Fallback for unknown reward types
    }
  }

  const newRewardNotes = handleRewardNotes();
  return (
    <StageAndPrizeCardContainer>
      <CardContainer backgroundColor="#F8F9FF">
        <CardWrapper>
          <StageCardHeading backgroundColor="#D7DBF5">
            {heading || ''}
          </StageCardHeading>
          <StageSubHeading>
            {sub_heading || ''}&nbsp;&nbsp;
            {sub_heading_hyperlink && (
              <span
                onClick={() =>
                  handleNotionOrExternalLink(sub_heading_hyperlink)
                }
                style={{ color: '#66cdf6', cursor: 'pointer' }}
              >
                click here <img src={LinkOut} />
              </span>
            )}
            &nbsp;&nbsp;
            {/* {moment(end_date).format('Do MMM')} */}
            {/* &nbsp;&nbsp; */}
            <LiveContainer
              color={
                checkContestStatus(end_date) ? '#54b585' : 'var(--Punch500)'
              }
            >
              <Dot
                bgColor={
                  checkContestStatus(end_date) ? '#54b585' : 'var(--Punch500)'
                }
              />
              &nbsp;
              {checkContestStatus(end_date) ? 'LIVE' : 'ENDED'}
            </LiveContainer>
          </StageSubHeading>
          <StageTable>
            <tbody>
              <tr>
                <td>Last Date to complete {min_words / 1000}k words ⌛</td>
                <td>{moment(end_date).format('Do MMM')}</td>
              </tr>
              <tr>
                <td>Results on 🎉</td>
                <td>{moment(result_date).format('Do MMM')}</td>
              </tr>
            </tbody>
          </StageTable>
          <FlexContainer>
            <MinWidthSetter>
              <ImportantNoteIcon width={'34'} height={'34'} />
            </MinWidthSetter>
            <div>
              <NotesPoints>
                {important_points}
                <br />
                <p style={{ 'white-space': 'pre-wrap' }}>{notes}</p>
              </NotesPoints>
              <CardChevronBtn onClick={toggleExtraInfoHandler}>
                <ChevronDown width="24" height="24" fillOpacity="1" />
              </CardChevronBtn>
            </div>
          </FlexContainer>
        </CardWrapper>
        <Text variant="titleLarge" fontSize={24} my={16} textAlign="center">
          Contest Prizes
        </Text>
        <VerticalCenterItems>
          <StyledPrize1Div>
            <StyledTrophy src={Stage1} alt="Prize 1" />
            {props.winner1_no && (
              <StyledWinnersLabel>
                {props.winner1_no} {props.winner1_no > 1 ? 'WINNERS' : 'WINNER'}
              </StyledWinnersLabel>
            )}
            <StyledRewards>
              <StyledRewardAmount>
                {getRewardAmountCoin(
                  props?.winner1_amount,
                  props?.winner1_coin
                )}
              </StyledRewardAmount>
              <div style={{ display: 'flex' }}>
                <StyledRewardNote>{props.winner1_reward_note}</StyledRewardNote>
              </div>
            </StyledRewards>
          </StyledPrize1Div>
          <StyledPrize2Div>
            <StyledTrophy2 src={Stage2} alt="Prize 2" />
            {props.winner2_no && (
              <StyledWinnersLabel>
                {props.winner2_no} {props.winner2_no > 1 ? 'WINNERS' : 'WINNER'}
              </StyledWinnersLabel>
            )}
            <StyledRewards>
              <StyledRewardAmount>
                {getRewardAmountCoin(
                  props?.winner2_amount,
                  props?.winner2_coin
                )}
              </StyledRewardAmount>
              <div style={{ display: 'flex' }}>
                <StyledRewardNote>{props.winner2_reward_note}</StyledRewardNote>
              </div>
            </StyledRewards>
          </StyledPrize2Div>
          <StyledPrize3Div>
            {props.winner3_no && (
              <StyledWinnersLabel>
                {props.winner3_no} {props.winner3_no > 1 ? 'WINNERS' : 'WINNER'}
              </StyledWinnersLabel>
            )}
            <StyledTrophy src={Stage3} alt="Prize 3" />
            <StyledRewards>
              <StyledRewardAmount>
                {getRewardAmountCoin(
                  props?.winner3_amount,
                  props?.winner3_coin
                )}
              </StyledRewardAmount>

              <div style={{ display: 'flex' }}>
                <StyledRewardNote>{props.winner3_reward_note}</StyledRewardNote>
              </div>
            </StyledRewards>
          </StyledPrize3Div>

          {props?.extraWinners?.length > 0 && (
            <Box width="90%" mb={8} mt={8}>
              <StyledButton
                width="100%"
                variant="outlinePrimary"
                onClick={() => toggleShowAllPrizes(true)}
              >
                View All
              </StyledButton>
            </Box>
          )}
          {isAllPrizesShown && (
            <AllPrizesPopup
              onClose={() => toggleShowAllPrizes(false)}
              getRewardAmountCoin={getRewardAmountCoin}
              {...props}
            />
          )}
          {imp_reward_notes && (
            <div>
              <ul style={{ padding: '16px' }}>
                {imp_reward_notes.split('\n')?.map((impNote) => (
                  <li style={{ display: 'flex' }}>
                    <MinWidthSetter>
                      <ImportantNoteIcon width={'34'} height={'34'} />
                    </MinWidthSetter>
                    <p style={{ 'white-space': 'pre-wrap' }}>{impNote}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <Prize4Div>
            <RewardNoteBottom src={trophy4_bottom} />
            <div style={{ display: 'flex' }}>
              <ul>
                {newRewardNotes.map((note) => (
                  <li key={note}>{note} </li>
                ))}
              </ul>
            </div>
          </Prize4Div>
          <BtnContainer>
            <Button
              onClick={() =>
                handleJoinContestBtn('contest_details', {
                  module_name: 'Enter into the Contest',
                  entity_type: 'contest',
                })
              }
            >
              Enter into the Contest
            </Button>
          </BtnContainer>
        </VerticalCenterItems>
      </CardContainer>
    </StageAndPrizeCardContainer>
  );
}
